(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
const sidebarOffcanvas = document.getElementById('sidebarOffcanvas');
sidebarOffcanvas.addEventListener('hidden.bs.offcanvas', function () {
  document.getElementById("main-navbar").classList.remove("sidebar--open");
})
sidebarOffcanvas.addEventListener('show.bs.offcanvas', function () {
  document.getElementById("main-navbar").classList.add("sidebar--open");
})

// For Announcement Bar Animation

function animateAnnouncements() {
  let announcements = document.getElementById("announcements").children;
  let currentAnnoucement = 1;
  if(announcements.length < 2){
    return;
  }
  setInterval(function () {
    let previousAnnouncement = (announcements.length + currentAnnoucement - 1) % announcements.length;
    announcements[previousAnnouncement].classList.remove("show");
    announcements[currentAnnoucement].classList.add('show');
    currentAnnoucement = (currentAnnoucement + 1) % announcements.length;
  }, 3000)  
}
animateAnnouncements();


  } catch(e) { console.error(e); }
})();
})();
